import { Component, OnInit } from '@angular/core';
import { MasterService } from '../../services/index';

import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons,NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-qpallotment',
  templateUrl: './qpallotment.component.html',
  styleUrls: ['./qpallotment.component.scss'],
  providers:[MasterService]
})
export class QpallotmentComponent implements OnInit {

  
  arrqseg:any=[];
  arrqcat:any=[];
  arresult:any=[];
  arrqbank:any=[];
  arranstype:any=[];
  arrevlmanswer:any=[];
  arrashead:any=[];
  objqbank:any={};
  objans:any={};
  selpub:any={};
  oprtype='';
  modalOptions:NgbModalOptions;
  private modalRef: NgbModalRef;
  fileToUpload: File = null;
  constructor(private http: HttpClient, private mservice: MasterService,private modalService: NgbModal) { }

  ngOnInit(): void {
    
    // this.sel_evlmqbank('select',1);
    // this.sel_evlmanstype();
    // this.sel_evlmqcategory();
    this.sel_evltbluebook();
    this.mascourse();
  }



  masclass() {
    this.mservice.masclass()
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.arranstype = resultArray;
            //this.objqbank.anstypeid=resultArray[0].anstypeid;
            this.masasshead();
        },
        error => console.log("Error :: " + error)
        )
  }


  mascourse() {
    this.mservice.mascourse()
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.arrqcat = resultArray;
            //this.objqbank.qucatid=resultArray[0].qucatid;
            this.masclass();
        },
        error => console.log("Error :: " + error)
        )
  }

 
  masasshead() {
    this.mservice.sel_sp_masasshead()
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.arrashead= resultArray.filter(function(arr)
            {
        
              return arr.ascat=='Competitive';
              
            })
             
            //this.objfilt.asid=resultArray[0].asid;
           // this.fmodel.assid=resultArray[0].asid;
           this.sel_evlmqpaperh();
        },
        error => console.log("Error :: " + error)
        )
  }

  sel_evlmqpaperh() {
    this.mservice.sel_evlmqpaperh()
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.arrqseg = resultArray;
           // this.objqbank.qusegid=resultArray[0].qusegid;
            //this.SelectClsSubDetails();
        },
        error => console.log("Error :: " + error)
        )
  }



  openasses(content,objdata,cmd) {
    debugger
    this.oprtype=cmd;
    if(cmd=='insert')
    {
      this.objqbank={};
     
      
      
      this.objqbank.cesid='0';
      this.objqbank.stdt=this.mservice.getdatetoday();
      this.objqbank.endt=this.mservice.getdatetoday();

      this.objqbank.oprtype='insert';
     
    }
  
    else if(cmd=='update')
    {
      
      this.objqbank=objdata;
      this.objqbank.oprtype='update';
    }
    
    this.modalOptions = {
      backdrop:'static',
      backdropClass:'customBackdrop',
      size:'lg'
     
    }
    this.modalRef=this.modalService.open(content,this.modalOptions);
    
    this.modalRef.result.then((result) => {
   
         
      }, (reason) => {
          
      });
  }


  opendetails(content,objdata) {
    debugger
      this.objans=objdata;
      // this.objqbank.oprtype='update';
    
    this.sel_evlresult(objdata.cesid);
    this.modalOptions = {
      backdrop:'static',
      backdropClass:'customBackdrop',
      size:'lg'
     
    }
    this.modalRef=this.modalService.open(content,this.modalOptions);
    
    this.modalRef.result.then((result) => {
   
         
      }, (reason) => {
          
      });
  }


  upload(files: FileList) {
    debugger;
    console.log(files);

    if (files[0].type=="image/jpeg"|| files[0].type=="image/jpg" || files[0].type=="image/png")
    {

    this.fileToUpload = files.item(0);
    }
    else{

      alert('Please upload valid image.');
    }
  
   // this.fData.append("bkid", this.memid.toString());
    //this.fData.append("docpurpose", "Studentphoto");
  
    // this.SService.uploadFile(fData).subscribe(
    //     response => this.handleResponse(response),
    //     error => this.handleError(error)
    // )
  }

  saveastype()
{
 console.log('saveobj',this.objqbank);

 const str = this.objqbank.stdt;
const d = new Date(str);

console.log(`${d.toLocaleDateString()} ${d.toLocaleTimeString()}`);

console.log(`${d.toLocaleDateString().replace(/\//g,'-')} ${d.toLocaleTimeString('en-US', {hour: '2-digit', minute:'2-digit'})}`);
this.mservice.save_evltbluebook(this.objqbank)
      .subscribe(
      result => {
          console.log('SavegenmasDetails', result);
          //this.suppliers = resultArray;
          alert(result.message);
          if(result.status=='success')
          {
            let localmodref=this.modalRef;
            localmodref.close();
          //  this.masasstype();
          this.sel_evltbluebook();
          }
         else
         {

         }
      },
      error =>{ alert('Error While saving...');}
      )

}

deletepaper(obj)
{
  if(confirm("Are you sure ? you want to delete."))
  {

    this.objqbank=obj;
    this.objqbank.oprtype="delete";

    this.saveastype();
  }

}





sel_evltbluebook() {
  this.mservice.sel_evltbluebook()
      .subscribe(
      resultArray => {
          console.log('getdashcounts', resultArray);
          this.arrqbank = resultArray;

         
      },
      error => console.log("Error :: " + error)
      )
}

sel_evlresult(cesid) {
  this.mservice.sel_evlresult(cesid)
      .subscribe(
      resultArray => {
          console.log('getdashcounts', resultArray);
          this.arresult = resultArray;

         
      },
      error => console.log("Error :: " + error)
      )
}

printpayack(cesid){
  var clcd=localStorage.getItem('clcd');
  var aycd=localStorage.getItem('aycd');
   var url=this.mservice.callurl+"fpdf181/pdfreports/ceranking.php?clcd="+clcd+"&aycd="+aycd+"&cesid="+cesid;
   window.open(url,'','');

//http://43.247.158.94:8081/mycampuz/api/v3/fpdf181/pdfreports/payreceipt.php
   
 }

}

